import Axios from '../../library/Axios'

export const CommentPostAction = (type: string, id: string, name: string, mobile: string, comment: string) => async (dispatch: any) => {
    try {
        let postUrl = '';

        let params: any = {
            name: name,
            mobile: mobile,
            comment: comment
        }

        if (type == 'campaign') {
            dispatch({ type: 'CAMPAIGN_COMMENT_POST_REQUEST' })
            params['campaign_id'] = id
            postUrl = '/post/submit/comment';

        } else if (type == 'blog') {
            dispatch({ type: 'BLOG_COMMENT_POST_REQUEST' })
            params['blog_id'] = id
            postUrl = '/post/submit/blog/comment';

        } else if (type == 'product') {
            dispatch({ type: 'PRODUCT_COMMENT_POST_REQUEST' })
            params['product_id'] = id
            postUrl = '/post/submit/product/comment';
        }

        const { data } = await new Axios().post(postUrl, params)

        if (type == 'campaign') {
            dispatch({ type: 'CAMPAIGN_COMMENT_POST_SUCCESS', payload: data })

        } else if (type == 'blog') {
            dispatch({ type: 'BLOG_COMMENT_POST_SUCCESS', payload: data })

        } else if (type == 'product') {
            dispatch({ type: 'PRODUCT_COMMENT_POST_SUCCESS', payload: data })
        }
    } catch (error) {
        if (type == 'campaign') {
            dispatch({ type: 'CAMPAIGN_COMMENT_POST_ERROR' })

        } else if (type == 'blog') {
            dispatch({ type: 'BLOG_COMMENT_POST_ERROR' })

        } else if (type == 'product') {
            dispatch({ type: 'PRODUCT_COMMENT_POST_ERROR' })
        }
    } finally {
        if (type == 'campaign') {
            dispatch({ type: 'CAMPAIGN_COMMENT_POST_RESET' })

        } else if (type == 'blog') {
            dispatch({ type: 'BLOG_COMMENT_POST_RESET' })

        } else if (type == 'product') {
            dispatch({ type: 'PRODUCT_COMMENT_POST_RESET' })
        }
    }
}